import { Fragment } from 'react';
import {
  togglePdpModal,
  toggleRdpModal,
} from '../generic/global_state/action_creators';
import { connect } from 'react-redux';
import PDPModalContainer from './../generic/product/PDPModalContainer';
import RDPModal from '../generic/RdpModal';
import CyoModal from '../generic/CyoModal';
import { toggleCyoModal } from './cyo_redux/cyo_actions_creators';

const OrderDetailsModals = ({
  togglePdpModal,
  cyoVisible,
  toggleCyoModal,
  renderCustomerCyo,
  rdpPairing,
  toggleRdpModal,
}) => {
  const onClosingCyoModal = () => {
    toggleCyoModal();
    renderCustomerCyo();
  };

  return (
    <Fragment>
      <PDPModalContainer
        isCustomizationPage={false}
        togglePdpModal={togglePdpModal}
      />
      <RDPModal
        pairing={rdpPairing}
        visible={!!rdpPairing}
        onClose={() => toggleRdpModal(null)}
      />
      <CyoModal visible={cyoVisible} onClose={onClosingCyoModal} />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    cyoVisible: state.cyo,
    rdpPairing: state.rdpModal.pairing,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    togglePdpModal: (p) => dispatch(togglePdpModal(p)),
    toggleRdpModal: (p) => dispatch(toggleRdpModal(p)),
    toggleCyoModal: () => dispatch(toggleCyoModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailsModals);
